import React from "react";
import { Navigate, Route } from "react-router-dom";

// Employee Components
import EmployeeSignIn from "Pages/EmployeeDashboard/authentication/sign-in/signIn";
import ShortListEmployeeForm from "Pages/EmployeeDashboard/ShortListEmployeeForm/ShortListEmployeeForm";
import InterviewSchedule from "Pages/EmployeeDashboard/ShortListEmployeeForm/InterviewSchedule";
import EmployeeComplaintDetail from "Pages/EmployeeDashboard/Complaints/ComplaintDetail";
import EmployeeAnnouncementDetail from "Pages/EmployeeDashboard/dashboard/components/Announcement/employeeAnnouncementDetail";
import AddEmployeeExpense from "Pages/EmployeeDashboard/ExpenseManagment/ExpenseManagment";
import ProtectedRoute from "Pages/AdministratorDashboard/authentication/ProtectedHRFile/ProtectedHRFile";
import EmployeeCalender from "./EmployeeAttendence/EmployeeCalender";
import DayDetail from "./EmployeeAttendence/DayDetail";
import CheckReviews from "./PerformanceReview/CheckReviews";
import EmployeePerformanceReview from "./PerformanceReview/EmployeePerformanceRvw";
import PerformanceReviewForm from "./PerformanceReview/PerformanceReview";
import PerformanceReviewReport from "./PerformanceReview/PerformanceReviewReport";
import ExpenseManagementList from "./ManageExpenses/ExpenseManagment";
import EmployeeExpenseRequest from "./ManageExpenses";
import EmployeeDetail from "./Employees/EmployeeDetail";
const RedirectToDashboard = () => <Navigate to="/employeedashboard" />;
const EmployeeRoutes = () => (
  <React.Fragment>
    <Route path="/" element={<ProtectedRoute element={<RedirectToDashboard />} />} />
    <Route path="/empsignIn" name="Sign In" element={<EmployeeSignIn />} />

    <Route
      path="/shortlistEmployeeform"
      name="Short List Employee Form"
      element={<ShortListEmployeeForm />}
    />
    <Route
      path="/interviewSchedule/:id"
      name="Interview Schedule"
      element={<ProtectedRoute element={<InterviewSchedule />} />}
    />
    <Route
      path="/employeedashboard/empcomplaintDetail/:complaintId"
      name="Complaint Detail"
      element={<ProtectedRoute element={<EmployeeComplaintDetail />} />}
    />
    <Route
      path="/employeedashboard/addEmployeeExpense"
      name="Add Employee Expense"
      element={<ProtectedRoute element={<AddEmployeeExpense />} />}
    />

    <Route
      path="/employeedashboard/emp-announcement-detail/:announcementId"
      element={<ProtectedRoute element={<EmployeeAnnouncementDetail />} />}
    />
    <Route
      path="/employeedashboard/attendance/viewdetail"
      element={<ProtectedRoute element={<EmployeeCalender />} />}
    />

    <Route
      path="/employeedashboard/attendance/daydetail"
      element={<ProtectedRoute element={<DayDetail />} />}
    />

    {/* Manager routes*/}

    {/* Performance review */}

     <Route
          path="/employeedashboard/performance-review/check-review"
          element={<ProtectedRoute element={<CheckReviews />} />}
        />
    
        <Route path="/employeedashboard/performance-review" element={<EmployeePerformanceReview />} />
        <Route
     path="/employeedashboard/performance-review/form"
      element={<ProtectedRoute element={<PerformanceReviewForm />} />}
   /> 

    <Route
       path="/employeedashboard/performance-review/report"
       element={<ProtectedRoute element={<PerformanceReviewReport />} />}
    />

    {/*Expense Mangement*/}
     <Route path="/employeedashboard/expense-management" element={<ExpenseManagementList />} />
 
 <Route
       path="/employeedashboard/expenseManagementReport"
       element={<ProtectedRoute element={<EmployeeExpenseRequest />} />}
   />

    <Route
         path="/employeedashboard/employeeDetail/:empId"
         name="Employee Details"
         element={<ProtectedRoute element={<EmployeeDetail />} />}
       />

  </React.Fragment>
);

export default EmployeeRoutes;
